<div class="crm-lead-filters">
  <div class="crm-lead-filters-title">{{ 'APP.CRM.LEAD_FILTERS.TITLE' | translate }}</div>
  <p class="crm-lead-filters-description">{{ 'APP.CRM.LEAD_FILTERS.DESCRIPTION' | translate }}</p>
  <div class="crm-lead-filters-note d-flex align-items-start">
    <ng-icon [name]="'heroInformationCircle'" [size]="'18px'" [strokeWidth]="'2'" [color]="'#6C6176'"
      class="crm-lead-filters-note-icon"></ng-icon>
    <span [innerHTML]="'APP.CRM.LEAD_FILTERS.NEW_ONLY_NOTE' | translate:{appName: app?.name}"></span>
  </div>
  <div *ngFor="let option of options" class="crm-lead-filter d-flex align-items-center justify-content-between">
    <div class="d-flex flex-column">
      <span class="crm-lead-filter-label">{{ option.labelKey | translate }}</span>
      <span class="crm-lead-filter-help">{{ option.helpKey | translate }}</span>
    </div>
    <rosie-switch [ariaLabel]="option.labelKey | translate" [control]="form.get(option.key)" [labelTranslationKey]="option.labelKey" class="d-flex">
    </rosie-switch>
  </div>
</div>
